import { render, staticRenderFns } from "./ChamadoHistorico.vue?vue&type=template&id=7f6081f0&scoped=true&"
import script from "./ChamadoHistorico.vue?vue&type=script&lang=js&"
export * from "./ChamadoHistorico.vue?vue&type=script&lang=js&"
import style0 from "./ChamadoHistorico.vue?vue&type=style&index=0&id=7f6081f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6081f0",
  null
  
)

export default component.exports